import { unix } from 'dayjs'

export const isMatchingFixedDateSeparatorVisible = (
  container: HTMLElement,
  timestamp: number,
): boolean => {
  const containerRect = container.getBoundingClientRect()
  const targetDay = unix(timestamp).tz()

  return Array.from(
    container.querySelectorAll('[data-chat-date-separator]'),
  ).some((node) => {
    const nodeTs = Number(node.getAttribute('data-timestamp'))
    if (!nodeTs || !unix(nodeTs).tz().isSame(targetDay, 'day')) {
      return false
    }

    const rect = node.getBoundingClientRect()
    return rect.bottom > containerRect.top && rect.top < containerRect.bottom
  })
}
